import React from 'react'
import dayjs from 'dayjs'

const pick = (obj, ...keys) => {
    if (!obj) return undefined
    for (const key of keys) {
        if (obj[key] !== undefined && obj[key] !== null) {
            return obj[key]
        }
    }
    return undefined
}

export default ({ uploadData }) => {
    const data = uploadData ? uploadData.upload || uploadData : null
    const uploadStatus = pick(data, 'UploadStatus', 'uploadStatus')
    const reviewDate = pick(data, 'ReviewDate', 'reviewDate')
    const comment = pick(data, 'Comment', 'comment')
    const isEDD = pick(data, 'IsEDD', 'IsEdd', 'isEdd')

    if (uploadStatus === 3) {
        return (
            <div className="column is-12">
                <div className="notification is-danger">
                    <p>
                        This {isEDD ? `EDD` : `form`} was denied on {dayjs(reviewDate).format('MM/DD/YYYY').toString()} with the following comments:
                    </p>
                    <p>
                        {comment}
                    </p>
                    <p>
                        {isEDD ? <span>Please <b>submit a new EDD that addresses the attached comments</b>.</span> : <span>Please submit <b>a new form that addresses the attached comments.</b></span>}
                    </p>
                </div>
            </div>
        )
    } else if (uploadStatus === 2) {
        return (
            <div className="column is-12">
                <div className="notification is-success">
                    <p>
                        This {isEDD ? `EDD` : `form`} was approved on {dayjs(reviewDate).format('MM/DD/YYYY').toString()} with the following comments:
                    </p>
                    <p>
                        {comment ? comment : 'No comment provided'}
                    </p>
                    <p>
                        The data associated with this submission is now live.
                    </p>
                </div>
            </div>
        )
    } else {
        return null
    }
}
